<template>
  <div>
    <ModalBase :show-modal="showModal" @close-modal="close" :auto-h="true" :narrow="true" :overlay-scrollb="false" class="bank-account-delete-modal">
        <template v-slot:titlebar>
          <TitleBar variant-class="title-modal">
            <template v-slot:title>
              {{ $gettext('Delete bank account') }}
            </template>
          </TitleBar>
        </template>

        <template v-slot:maincontent>
          <div class="content">
            <div class="account-info-wrap">
              <div class="account-info">
                <span class="label">IBAN</span> <strong>{{ selectedAccount.iban | formatIBAN }}</strong>
              </div>
              <div v-if="selectedAccount.alias" class="account-info">
                <span class="label">ALIAS</span> {{ selectedAccount.alias }}
              </div>
            </div>
            <p v-translate>
              Deleting this bank account will remove all transactions from your Gekko account. While it is possible to upload the transactions again, please be aware that existing connections to costs and invoices will be deleted permanently. This means that any existing payments on invoices and cost items will remain but will no longer be connected to transactions.
            </p>
            <p>
              <b-form-checkbox v-model="checkAccepted">
                {{ $gettext('I understand the implications and want to delete this bank account.') }}
              </b-form-checkbox>
            </p>
          </div>
        </template>

        <template v-slot:actions>
          <div class="d-flex justify-content-between">
            <GekkoButton 
              @click="close" 
              :text="$gettext('Cancel')"
              variant="link"
              class="text-primary px-0"
            />
            <GekkoButton 
              @click="deleteAccount" 
              :disabled="!checkAccepted"
              :text="$gettext('Delete')"
              variant="danger"
            />
          </div>
        </template>
    </ModalBase>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import GekkoButton from '@/components/GekkoButton';
import ModalBase from "@/components/base_components/ModalBase";
import TitleBar from "@/components/TitleBar";

export default {
  name: "BankAccountDeleteModal",
  components: { GekkoButton, ModalBase, TitleBar },
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      checkAccepted: false
    }
  },
  computed: {
    ...mapGetters ({ 
      selectedAccount: "bankStore/getSelectedAccount"
    })
  },
  created () {
  },
  methods: {
    ...mapActions ({
      deleteBankAccount: "bankStore/deleteBankAccount"
    }),
    close () {
      document.body.classList.remove('modal-on')
      this.$emit('close', false)
    },
    deleteAccount () {
      this.deleteBankAccount(this.selectedAccount.id).then(() => {
        this.$emit('account-deleted', false)
      }).catch(() => {
        this.$store.commit('setAlert', {
            title: this.$gettext("Error"),
            text: this.$gettext("Your bank connection could not be deleted."),
            variant: 'danger',
            duration: 4
          });
      });
    }
  }
}
</script>

<style lang="scss">
.bank-account-delete-modal .gk-modal {
  max-width: 750px !important;
}
</style>
<style lang="scss" scoped>
.bank-account-delete-modal {
  .account-info-wrap {
    padding: 1.5rem;
    margin-bottom: 1.5rem;
    border-radius: $radiusLg;
    border: 1px solid $colorBorderDash;
    background: $colorBgSidebar;
    .account-info {
      .label {
        color: #7A7A7A;
        font-size: 14px;
        width: 70px;
        display: inline-block;
      }
    }
  }

}
</style>